import React from 'react'
import PropTypes from 'prop-types'

// Components
import IconQuestion from 'ui/Icons/IconQuestion'
import Button from 'ui/Button'
import Text from 'ui/Text'

export const NeedHelp = ({ title, onClick }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', padding: '20px 25px 20px 10px' }}>
      <IconQuestion width="90px" height="90px" />
      <div style={{ marginLeft: '15px' }}>
        <Text size={16} bold color="#222222">
          {title}
        </Text>
        <Text size={16} color="#070707">
          For any questions/concerns regarding your electronic CWT (BIR 2307),
          you may send us a message below
        </Text>
        <Button variant="link" underline onClick={onClick}>
          Raise a ticket
        </Button>
      </div>
    </div>
  )
}

NeedHelp.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
}

NeedHelp.defaultProps = {
  title: 'Need help?',
  onClick: () => {},
}

export default NeedHelp
